import { makeStyles } from "@material-ui/core";
import useTranslation from "next-translate/useTranslation";
import React from "react";
import { TheCycleverseTheme } from "src/theme";

const useStyles = makeStyles((theme: TheCycleverseTheme) => ({
  blueText: {
    color: theme.blueTextColor,
  },

  greenText: {
    color: theme.greenColor,
  },

  orangeText: {
    color: theme.lightOrangeColor,
  },

  redText: {
    color: theme.darkOrangeColor,
  },
}));

export const TableExplanation = ({ display, field1 }) => {
  const { t } = useTranslation("ritzelRechner");
  const classes = useStyles();
  return (
    <div style={{ marginTop: "10px" }}>
      <div>{`R = ${t("tableExplanation5")}`}</div>
      <div>{`K = ${t("tableExplanation6")}`}</div>
      <div>{`Anz = ${t("tableExplanation7")}`}</div>
      <div className={classes.blueText}>{t("tableExplanation1")}</div>
      <div className={classes.greenText}>{t("tableExplanation2")}</div>
      <div>
        {display() && Number(field1) > 1 ? (
          <>
            <span className={classes.orangeText}>{t("tableExplanation1")}</span> <span>{t("and")} </span>{" "}
            <span className={classes.redText}>{t("tableExplanation3")}</span> <span>{t("tableExplanation4")}</span>{" "}
          </>
        ) : null}
      </div>
    </div>
  );
};
